export const formatUser = (userState) =>
  Object({
    name: `${userState.firstName} ${userState.lastName}`,
    email: userState.email,
    phone: userState.phone
  });
